export class DataSourceResults {
    data : any[] ;
    total : number ;
}